// extracted by mini-css-extract-plugin
module.exports = {"bg":"GridBg_bg__2NDNY"};